import React from "react";
import ManagerView from "../components/managercomponents/ManagerView";

const Managerpage = () => {
  return (
    <div>
      <ManagerView />
    </div>
  );
};

export default Managerpage;
